"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUEUE_INCOMING_ACTIVITY = void 0;
exports["default"] = queueIncomingActivity;
var QUEUE_INCOMING_ACTIVITY = 'DIRECT_LINE/QUEUE_INCOMING_ACTIVITY';
exports.QUEUE_INCOMING_ACTIVITY = QUEUE_INCOMING_ACTIVITY;

function queueIncomingActivity(activity) {
  return {
    type: QUEUE_INCOMING_ACTIVITY,
    payload: {
      activity: activity
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJRVUVVRV9JTkNPTUlOR19BQ1RJVklUWSIsInF1ZXVlSW5jb21pbmdBY3Rpdml0eSIsImFjdGl2aXR5IiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9xdWV1ZUluY29taW5nQWN0aXZpdHkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgUVVFVUVfSU5DT01JTkdfQUNUSVZJVFkgPSAnRElSRUNUX0xJTkUvUVVFVUVfSU5DT01JTkdfQUNUSVZJVFknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBxdWV1ZUluY29taW5nQWN0aXZpdHkoYWN0aXZpdHkpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBRVUVVRV9JTkNPTUlOR19BQ1RJVklUWSxcbiAgICBwYXlsb2FkOiB7IGFjdGl2aXR5IH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgUVVFVUVfSU5DT01JTkdfQUNUSVZJVFkgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHVCQUF1QixHQUFHLHFDQUFoQzs7O0FBRWUsU0FBU0MscUJBQVQsQ0FBK0JDLFFBQS9CLEVBQXlDO0VBQ3RELE9BQU87SUFDTEMsSUFBSSxFQUFFSCx1QkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsUUFBUSxFQUFSQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=